import { render, staticRenderFns } from "./PersonalSummary.vue?vue&type=template&id=3bc71dbf"
import script from "./PersonalSummary.vue?vue&type=script&lang=js"
export * from "./PersonalSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports